import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { FactureService } from 'src/app/service/facture.service';
import { AppSettings } from 'src/app/service/app.setting';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Router } from '@angular/router';
import { InvitationVisaService } from 'src/app/service/invitation.visa.service';
import { Invitations } from 'src/app/entity/invitation';
import { ComposeMailComponent } from 'src/app/view/email/include/compose-mail/compose-mail.component';
import { MailsService } from 'src/app/service/mails.service';
import { Client } from 'src/app/entity/exhibitor';
import { CertificatDouane } from 'src/app/entity/certificat.douane';
import { CertificatdouaneService } from 'src/app/service/certificatdouane.service';
//import { saveAs } from 'file-saver/FileSaver';
@Component({
  selector: 'app-options-exposants',
  templateUrl: './options-exposants.component.html',
  styleUrls: ['./options-exposants.component.css']
})
export class OptionsExposantsComponent implements OnInit, OnChanges {
  @Input() idClient: number;
  @Input() selectedClient: Client;
  visibleDouane: boolean;
  visibleVisa: boolean;
  uploadedFiles: any[];
  attestaions: any[];
  douanes: CertificatDouane[];
  selectedDouane: CertificatDouane ;
  selectedInvitation: Invitations ;

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    this.reporting(this.idClient);
  }
  nbrMaterielSpecifiqueS: string = '';
  nbrDelegateS: string = '';
  nbrPubliciteS: string = '';
  nbrVisa: string = '';
  nbrAttestation: string = '';
  nbrBadge: string = '';
  isSigner: boolean = true;
  invitations: Invitations[];
  @ViewChild(ComposeMailComponent )
  private composeMailComponent: ComposeMailComponent;
  constructor(private factureService: FactureService, private router: Router, private mailsService: MailsService,
    private douaneService:CertificatdouaneService ,
    private clientService: ExhibitorService,
    private invitationVisaService: InvitationVisaService

  ) { }

  ngOnInit() {
  }
  reporting(idClient: number) {
    this.findAllDouane();

    this.invitationVisaService.getByExhibitor(idClient).subscribe(result => {
      this.invitations = result;
      this.nbrVisa = result.length + ' Visas';
      let i = 0;
      if (result && i == 0)
        result.forEach(element => {

          i++;

        });
    });

    this.factureService.getAllLogistique(idClient).subscribe(result => {


      this.nbrMaterielSpecifiqueS = result.text1;
      this.nbrPubliciteS = result.text2;
      this.nbrDelegateS = result.text3;

      this.nbrBadge = result.text5;

    })
    /*
        this.factureService.findByClientFacture(idClient).subscribe(result => {
          let nbrSpec = 0;
          let nbrDelegate = 0;
          let nbrPublicite = 0;
          this.nbrMaterielSpecifiqueS = '';
          this.nbrDelegateS = '';
          this.nbrPubliciteS = '';
          result.forEach(factureDetail => {
            if (!factureDetail.idfacture.annuler) {
              if (factureDetail.produit.specifique)
                nbrSpec++;
              if (factureDetail.produit.delegate)
                nbrDelegate += factureDetail.quantite;
              if (factureDetail.designation.indexOf("CD")>0)
                nbrPublicite++;
    
            }
          });
          if (nbrSpec > 0)
            this.nbrMaterielSpecifiqueS = nbrSpec + " Type Materiels";
          if (nbrDelegate > 0)
            this.nbrDelegateS = nbrDelegate + " Participants";
          if (nbrPublicite > 0) 
            this.nbrPubliciteS = nbrPublicite + " Publicité";
    
    
        })*/
  }
  gotoLogistiques() {
    this.clientService.getEnCryptClient(this.idClient).subscribe(result => {
      let idSalon = AppSettings.ID_SALON;
      let idExpoDecalEncrypt = result.crypt;

      window.open('http://ecatalog.napec-dz.com/exposant/portal.aspx?SALON=' + idSalon + '&expid=' + idExpoDecalEncrypt, '_blank');
    })

  }

  printDouane(type: string) {
    //console.log('this.isSigner' + this.isSigner);

    this.douaneService.printDouane(type, this.isSigner, true, this.selectedDouane.id_certificat_douane).subscribe(
      (res: any) => {

        var filename = this.selectedClient.raisonSocial + '.' + type;

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        var FileSaver = require('file-saver');
        FileSaver.saveAs(res, filename);
        if (type == 'pdf') {

          var fileURL = URL.createObjectURL(res);
         
        }
        this.visibleDouane = false;
      }
    );
  }
  sendDouane() {


    this.uploadedFiles = []
    this.douaneService.printDouane("pdf", this.isSigner, true, this.selectedDouane.id_certificat_douane).subscribe(
      (res: any) => {

        var filename = this.selectedClient.raisonSocial + ".pdf";

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        var FileSaver = require('file-saver');
        FileSaver.saveAs(res, filename);

        res.name = filename;

        this.uploadedFiles.push(res);
        this.mailsService.findodel(49).subscribe(result => {
          //  prepareEmailModel(modelCores: Modelcores, contact: Contact, projet: string, prospect: Prospect, uploadedFiles: any[])
          this.composeMailComponent.prepareEmailModel(result, this.selectedClient.contact, '', null, this.uploadedFiles)
        })


        this.visibleDouane = false;
      }
    );



    /*
      this.delegateService.print(this.selectedDelegate).subscribe(
        (res) => {
          var filename = this.selectedDelegate.nom + 'badge.pdf';
    
          filename = filename.replace(/[/\\?%*:|"<>]/g, '');
          res.name = filename;
          this.uploadedFiles.push(res);
    
    
          this.mailsService.findodel(nbr).subscribe(result => {
    
            this.composeMailComponent.prepareEmailModelDelegate(result, this.selectedDelegate, this.uploadedFiles)
          })
    
        }
      );*/

  }
  printInvitation(type: string, typeInvitation: string ) {
    //console.log('this.isSigner' + this.isSigner);

    this.invitationVisaService.printInvitations(type,this.isSigner, typeInvitation, this.selectedInvitation.id_invitation).subscribe(
      (res: any) => {

        var filename = 'invitationvisa.' + type;

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        var FileSaver = require('file-saver');
        FileSaver.saveAs(res, filename);

        var fileURL = URL.createObjectURL(res);
        window.open(fileURL);
        this.visibleDouane = false;
      }
    );
  }



  clickedMe() {
    this.router.navigateByUrl(`/add-exhibitor/${this.idClient}/6`)

  }
  updateInviation(inviation:Invitations){


    //console.log('input');
    
    this.invitationVisaService.updateInvitations(inviation).subscribe(
      result=>{
  
      }
    )
  }

updateDouane(douane:CertificatDouane){


  //console.log('input');
  
  this.douaneService.updateCertificatDouane(douane).subscribe(
    result=>{

    }
  )
}
addDouane( ){


  //console.log('input');
  let douane =new CertificatDouane();
  douane.entreprise=this.selectedClient.raisonSocial;
  douane.idClient=this.selectedClient.idClient;
  douane.date_envoie=new Date();
  this.douaneService.addCertificatDouane(douane).subscribe(
    result=>{
this.findAllDouane();
    }
  )
}
deleteDouane(douane:CertificatDouane){
  this.douaneService.deleteCertificatDouane(douane.id_certificat_douane).subscribe(result=>{
    this.findAllDouane();

  }
  )
}
  findAllDouane(){
    this.douaneService.findByExhibitor(this.idClient).subscribe(result=>{
      this.douanes=result;
if(result){
  this.nbrAttestation=result.length+' Attestations';
}
    }
    )
  }
}
